import { Pipe, PipeTransform } from '@angular/core';
import  moment from 'moment';
import 'moment/locale/pt-br';

@Pipe({
  name: 'data',
})
export class DataPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {

    if(!value)
      return "";          
      console.log(value);
      let format = "DD/MM/YYYY - HH:mm";
      if(args[0]){
        format = args[0];
      }
    return moment(value).format(format);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/data/data.ts